import { Component, OnInit, ViewChild } from '@angular/core';
import { REST_SERVICES } from 'src/app/_services/settings';
import { ZeroService } from '../../_services/zero/zero.service';
import { Alertas } from 'src/app/_models/alertas.model';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AlertasService } from 'src/app/_services/alertas.service';
import * as FileSaver from 'file-saver';
// import { ROUTE_ANIMATION_HOST } from 'src/app/app.routing.animation';

@Component({
    selector: 'app-alertas',
    templateUrl: './alertas.component.html',
    styleUrls:[ './alertas.component.css'], 
    // host: ROUTE_ANIMATION_HOST, 
    // animations: [ROUTE_ANIMATION_HOST]
  })

  export class AlertasComponent implements OnInit {
    public alertasList : Array<Alertas>;

    ngOnInit() {
      this.buscarAlertas();
    }

    constructor(
      private zeroService: ZeroService,
      private toastr: ToastrService,
      private router: Router,
      private alertas: AlertasService) {
      this.alertasList = new Array<Alertas>();
    }
  
    buscarAlertas() {
      let scope = this;
      scope.zeroService.request({
        isSingleResponse: false,
        uri: REST_SERVICES.BUSQUEDA_ALERTAS,
        method: "GET",
        showInfo: true,
        ok: (response) => {
          if (response.responsecode == "0") {
            scope.alertasList = response.response;
            
          }
        }
      });
     }

     exportarExcel(fileName: String){
      let scope = this;
      scope.zeroService.request({
        isSingleResponse: true,
        uri: REST_SERVICES.DOWNLOAD_REPORTE + fileName,
        method: "GET",
        showInfo: true,
        ok: (response) => {        
          console.log(response);
          this.descargaArcvhivo(response);
        },
      });
     }

     desactivarAlerta(id:number){
      let scope = this;
      scope.zeroService.request({
        isSingleResponse: false,
        uri: REST_SERVICES.DESACTIVAR_ALERTA + id,
        method: "PUT",
        showInfo: true,
        ok: (response) => {
          if (response.responsecode == "0") {
            scope.buscarAlertas();
            scope.toastr.success('<h5>Mensaje de sistema...</h5> <span>'+ response.responseMessage +'</span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
            scope.alertas.consultarTotalAlertas();
          }
        }
      });
     }

     verDetalle(idBin:number) {
      this.router.navigate(['/alertas', idBin, true], {
        queryParams: { refresh: new Date().getTime() }
      });
     }

     /**
   * Método que descarga el archivo recibido en la respuesta del microservicio
   * @param response    response obtenido de la respuesta del microservicio.
   */
  private descargaArcvhivo(response) {
    console.log("respose descarga", response);
    
    if (response.response.archivoReporte != null) {
      let base64data = this.base64ToBlob(response.response.archivoReporte);
      let blob = new Blob([base64data], { type: "text/csv;charset=utf-8;" });
      FileSaver.saveAs(blob, response.response.nombre);
      this.toastr.success(
        "<h5>Mensaje de sistema...</h5>El reporte " + `${response.response.nombre}`+", se ha descargado exitosamente <span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    } else {
      this.toastr.warning(
        "<h5>Mensaje de sistema...</h5>Error al descargar el reporte de bines<span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    }
  }

  /**
   * Metodo que retorna un blob el archivo recibido en base64
   * @param b64Data     Cadena en base64
   * @param sliceSize   
   */
  public base64ToBlob(b64Data, sliceSize = 512) {
    const byteCharacters = atob(b64Data); //data.file there
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);

      let byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {
      type: "apadsheetml.sheet",
    });
  }
  }
